<template>
	<div class="Wallet">
		<div class="Wallet_header"><SecondHead class="header_SecondHead"></SecondHead></div>
		<div class="Wallet_main">
			<el-tabs v-model="activeName" @tab-click="handleClick" class="Wallet_main_table">
				<el-tab-pane :label="$t('Mywallet.AccountBalance')" name="first">
					<div class="Wallet_main_deal">
						<ul class="Wallet_main_ul ul1">
							<li class="Wallet_main_li">{{$t('Mywallet.TransactionType')}} :</li>
							<!-- :class="{'ClickMain_a':trading(0)}" -->
							<li class="Wallet_main_li"><a  class="Wallet_main_a main_a" href="javascript:void(0)" @click="clickAll">{{$t('Mywallet.All')}}</a></li>
							<li class="Wallet_main_li"><a  class="Wallet_main_a main_a" href="javascript:void(0)" @click="trading(0)">{{$t('Mywallet.Other')}}</a></li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="trading(1)">{{$t('Mywallet.TextMessage')}}</a></li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="trading(2)">{{$t('Mywallet.Mail')}}</a></li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="trading(3)">{{$t('Mywallet.RedEnvelope')}}</a></li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="trading(4)">{{$t('Mywallet.Recharge')}}</a></li>
							<li class="Wallet_main_li"><a class="main_a" href="javascript:void(0)" @click="trading(5)">{{$t('Mywallet.Withdrawal')}}</a></li>
						</ul>
						<ul class="Wallet_main_ul ul2">
							<li class="Wallet_main_li">{{$t('Mywallet.CapitalFlow')}} :</li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="clickAll">{{$t('Mywallet.All')}}</a></li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="moneyFlows(0)">{{$t('Mywallet.Income')}}</a></li>
							<li class="Wallet_main_li"><a class="main_a" href="javascript:void(0)" @click="moneyFlows(1)">{{$t('Mywallet.Expenditure')}}</a></li>
						</ul>
					</div>
					<el-table :data="balance" style="width: 100%" center>
						<el-table-column prop="createtime" :label="$t('Mywallet.Time')" width="180"></el-table-column>
						<el-table-column prop="transactionName" :label="$t('Mywallet.TransactionName')"></el-table-column>
						<el-table-column prop="tradingType" :label="$t('Mywallet.TransactionType')" width="100"></el-table-column>
						<el-table-column prop="income" :label="`${$t('Mywallet.Income')}（${$t('Mywallet.RMB')}）`" width="100"></el-table-column>
						<el-table-column prop="expenditure" :label="`${$t('Mywallet.Expenditure')}（${$t('Mywallet.RMB')}）`" width="100"></el-table-column>
						<el-table-column prop="balance" :label="`${$t('Mywallet.AccountBalance')}（${$t('Mywallet.RMB')}）`" width="120"></el-table-column>
						<el-table-column prop="payWay" :label="$t('Mywallet.PaymentMethod')" width="100"></el-table-column>
					</el-table>
					<el-pagination class="balancepage" background layout="prev, pager, next" :total="balanceTotal" @current-change="balancepage"></el-pagination>
				</el-tab-pane>
				<el-tab-pane :label="$t('Mywallet.SMSBalance')" name="second">
					<div class="Wallet_main_deal">
						<ul class="Wallet_main_ul ul1">
							<li class="Wallet_main_li">{{$t('Mywallet.TransactionType')}} :</li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="note(100)">{{$t('Mywallet.All')}}</a></li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="note(0)">{{$t('Mywallet.SMSSending')}}</a></li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="note(3)">{{$t('Mywallet.SMSVerification')}}</a></li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="note(1)">{{$t('Mywallet.SMSGift')}}</a></li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="note(4)">{{$t('Mywallet.SMSGift')}}</a></li>
							<li class="Wallet_main_li"><a class=" main_a" href="javascript:void(0)" @click="note(2)">{{$t('Mywallet.SMSPurchase')}}</a></li>
						</ul>
					</div>
					<el-table :data="noteBalance" style="width: 100%">
						<el-table-column prop="createTime" :label="$t('Mywallet.Time')"></el-table-column>
						<el-table-column prop="useDetail" :label="$t('Mywallet.UsageDetails')"></el-table-column>
						<el-table-column prop="alterationNumber" :label="$t('Mywallet.SMSChangesPiece')"></el-table-column>
						<el-table-column prop="balanceNumber" :label="$t('Mywallet.SMSBalancePiece')"></el-table-column>
						<el-table-column prop="tradingType" :label="$t('Mywallet.ChangeType')"></el-table-column>
					</el-table>
					<el-pagination class="noteBalancePage" @current-change="noteBalancePage" background layout="prev, pager, next" :total="noteBalanceTotal" ></el-pagination>
				</el-tab-pane>
				<el-tab-pane :label="$t('Mywallet.MailBalance')" name="third">
					<div class="Wallet_main_deal">
						<ul class="Wallet_main_ul ul1">
							<li class="Wallet_main_li">{{$t('Mywallet.TransactionType')}} :</li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="emali(100)">{{$t('Mywallet.All')}}</a></li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="emali(0)">{{$t('Mywallet.EmailSending')}}</a></li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="emali(1)">{{$t('Mywallet.EmailGifts')}}</a></li>
							<li class="Wallet_main_li"><a class="Wallet_main_a main_a" href="javascript:void(0)" @click="emali(2)">{{$t('Mywallet.EmailPurchase')}}</a></li>
							<li class="Wallet_main_li"><a class=" main_a" href="javascript:void(0)" @click="emali(4)">{{$t('Mywallet.EmailReturn')}}</a></li>
						</ul>
					</div>
					<el-table :data="mailBalance" style="width: 100%">
						<el-table-column prop="createTime" :label="$t('Mywallet.Time')"></el-table-column>
						<el-table-column prop="useDetail" :label="$t('Mywallet.UsageDetails')"></el-table-column>
						<el-table-column prop="alterationNumber" :label="$t('Mywallet.EmailChangesPiece')"></el-table-column>
						<el-table-column prop="balanceNumber" :label="$t('Mywallet.EmailBalancePiece')"></el-table-column>
						<el-table-column prop="tradingType" :label="$t('Mywallet.ChangeType')"></el-table-column>
					</el-table>
					<el-pagination class="mailBalancePage" @current-change="mailBalancePage" background layout="prev, pager, next" :total="mailBalanceTotal"></el-pagination>
				</el-tab-pane>
			</el-tabs>
		</div>
		<!-- 对话框 -->
	</div>
</template>

<script>
import SecondHead from '@/components/SecondHead';
export default {
	name: 'TransactionRecord',
	components: {
		SecondHead
	},
	data() {
		return {
			mailBalanceTradingType:100,
			mailBalanceType:1,
			mailBalanceTotal: 0,
			mailBalance: [], // 邮件余额
			
			noteBalanceTradingType:100,
			noteBalanceType:0,
			noteBalanceTotal: 0,
			noteBalance: [], //短信余额

			balanceTradingType:{},//账户余额交易类型
			balanceTotal: 0,
			balance: [], //账户余额
			DataList: [],
			activeName: 'first'
		};
	},
	mounted: function() {
		this.loadList();
	},
	methods: {
		emali(val){
			this.mailBalanceTradingType = val;
			this.mailBalance=[]
			this.handleClick(2,1);
		},
		note(val){ //短信
			this.noteBalanceTradingType = val;
			this.noteBalance=[]
			this.handleClick(1,1);
		},
		mailBalancePage(val ){ //邮件余额分页\
			this.handleClick(2,val);
			console.log(val);
		},
		noteBalancePage(val) {//短信余额分页
			this.handleClick(1,val);
			console.log(val);
		},
		balancepage(val) {// 账户余额分页
			this.loadList(val);
		},
		
		handleClick(tab, val) {  //短信 邮件 数据查询
			if (tab.index == 1 || tab == 1) {
				let that = this;
				let pageIndex = val
				if (typeof pageIndex == 'object'){
					pageIndex = 1
				}
				let params = {
					that: this,
					url: `${this.$config.service.queryQuestionsCount}?type=${this.noteBalanceType}&tradingType=${this.noteBalanceTradingType}&pageSize=${10}&pageIndex=${pageIndex}`,
					method: 'GET',
					data: {},
					cb(res) {
						if (res.code == 0) {
							for(let i = 0; i<res.resultBody.datas.length; i++){
								let a =[that.$t('Mywallet.Sending'),that.$t('Mywallet.Give'),that.$t('Mywallet.Purchase'),that.$t('Mywallet.TestVerify'),that.$t('Mywallet.Return')]
								res.resultBody.datas[i].tradingType = a[res.resultBody.datas[i].tradingType]
							}
							that.noteBalanceTotal = res.resultBody.total;
							that.noteBalance = res.resultBody.datas;
						}
					}
				};
				this.$util.request(params);
				
			}else if (tab.index == 2 || tab == 2) {
				console.log(tab.index)
				let that = this;
				let pageIndex = val
				if (typeof pageIndex == 'object'){
					pageIndex = 1
				}
				let params = {
					that: this,
					url: `${this.$config.service.queryQuestionsCount}?type=${this.mailBalanceType}&tradingType=${this.mailBalanceTradingType}&pageSize=${10}&pageIndex=${pageIndex}`,
					method: 'GET',
					data: {}, 
					cb(res) {
						if (res.code == 0) {
							for(let i = 0; i<res.resultBody.datas.length; i++){
								let a =[that.$t('Mywallet.Sending'),that.$t('Mywallet.Give'),that.$t('Mywallet.Purchase'),that.$t('Mywallet.TestVerify'),that.$t('Mywallet.Return')]
								res.resultBody.datas[i].tradingType = a[res.resultBody.datas[i].tradingType]
							}
							that.mailBalanceTotal =  res.resultBody.total;
							that.mailBalance = res.resultBody.datas;
						}
					}
				};
				this.$util.request(params);
			} else {
			}
		},
		clickAll(){ //点击全部
			this.balanceTradingType = {}
			this.loadList()
		},
		moneyFlows(val){ //资金流向
			this.balanceTradingType.moneyFlows = val
			this.balance = []
			this.loadList()
		},
		trading(val){  //点击交易类型
			console.log(val)
			this.balanceTradingType.tradingType = val
			this.balance = []
			this.loadList()
		},
		loadList(val) {
			let that = this;
			let pageIndex = val;
			if (typeof pageIndex == 'undefined') {
				pageIndex = 1;
			}
			let radingRecordQuery = this.balanceTradingType
			console.log(radingRecordQuery)
			let params = {
				that: this,
				url: `${this.$config.service.queryTradingRecordpage}?pageIndex=${pageIndex}&pageSize=${10}`,
				method: 'POST',
				data: radingRecordQuery,
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody);
						for (let i = 0; i < res.resultBody.datas.length; i++) {
							let a = [that.$t('Mywallet.Other'), that.$t('Mywallet.TextMessage'), that.$t('Mywallet.Mailbox'), that.$t('Mywallet.RedEnvelope'), that.$t('Mywallet.Recharge'), that.$t('Mywallet.Withdrawal')];
							let b = res.resultBody.datas[i].tradingType;
							res.resultBody.datas[i].tradingType = a[b];

							let c = res.resultBody.datas[i].transactionName.split('<p>').join('-');
							let d = c.split('</p>').join('-');
							let e = d.split('-').join(' ');
							res.resultBody.datas[i].transactionName = e;
						}
						that.balanceTotal = res.resultBody.total;
						that.balance = res.resultBody.datas;
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style scoped="scoped" lang="scss">
.Wallet {
	width: 100%;
	min-height: 100%;
	background-color: #f5f5f5;
	.Wallet_header {
		width: 100%;
		height: 68px;
		background-color: #fff;
		.header_SecondHead {
			max-width: 1200px;
			margin: auto;
		}
	}
	.Wallet_main {
		width: 100%;
		margin-top: 10px;
		.Wallet_main_table {
			max-width: 1200px;
			min-height: 800px;
			background-color: #fff;
			padding: 20px;
			margin: auto;
		}
		.Wallet_main_deal {
			.Wallet_main_ul {
				height: 30px;
				line-height: 30px;
				display: flex;
				// justify-content: space-between;
				.Wallet_main_li {
					padding: 0px 12px;
					font-size: 14px;
					text-align: center;
					position: relative;
					.Wallet_main_a {
					}
					.main_a {
						color: #707070;
					}
					.ClickMain_a {
						color: #00aaff;
					}
				}
				.Wallet_main_li .Wallet_main_a::before {
					box-sizing: border-box;
					position: absolute;
					right: 0;
					color: #d8d8d8;
					content: '|';
				}
			}
			.ul1 {
				width: 650px;
			}
			.ul2 {
				width: 248px;
			}
		}
		.noteBalancePage {
			margin-top: 30px;
			float: right;
		}
		.mailBalancePage{
			margin-top: 30px;
			float: right;
		}
		.balancepage {
			margin-top: 30px;
			float: right;
		}
	}
}
</style>
